import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormValidation } from '../../../shared/forms/form-validation';
import { StateConstants } from '../../../shared/constants/state-constants';
import { State } from '../../../shared/state';

@Component({
  selector: 'rental-and-tow-customer',
  templateUrl: './rental-and-tow-customer.component.html'
})
export class RentalAndTowCustomerComponent implements OnInit {
  @Input() showInputLabels = true;

  public rentalAndTowCustomerForm: UntypedFormGroup;
  public formCompleted = false;
  public states: State[] = [];

  ngOnInit(): void {
    this.getStates();
    this.populateData();
  }

  public getStates(): void {
    this.states = StateConstants.GetAllUsStates();
  }

  public populateData() {
    this.rentalAndTowCustomerForm = new UntypedFormGroup({
      'firstName': new UntypedFormControl("", [Validators.required]),
      'lastName': new UntypedFormControl("", [Validators.required]),
      'contractNumber': new UntypedFormControl("", [Validators.required]),
      'streetAddress1': new UntypedFormControl("", [Validators.required]),
      'streetAddress2': new UntypedFormControl(),
      'city': new UntypedFormControl("", [Validators.required]),
      'state': new UntypedFormControl("", [Validators.required]),
      'zip': new UntypedFormControl("", [Validators.required, Validators.pattern(/^\d{5}(?:[-\s]\d{4})?$|[a-zA-Z]\d[a-zA-Z] ?\d[a-zA-Z]\d/)]),
      'phoneNumber': new UntypedFormControl("", [Validators.required, Validators.pattern(/^\d{10}$|^\d{3}-\d{3}-\d{4}$/)]),
      'customerConcern': new UntypedFormControl()
    });
  }
  //** Validates the customer form and sets formCompleted to valid or invalid */
  public validateForm(): void {
    this.rentalAndTowCustomerForm.get('phoneNumber').setValue(this.formatPhoneNumber(this.rentalAndTowCustomerForm.get('phoneNumber').value));
    this.formCompleted = FormValidation.isValid(this.rentalAndTowCustomerForm);    
  }

  public formatPhoneNumber(phoneNumber: string): string {
    if (phoneNumber.match(/^\d{3}-\d{3}-\d{4}$/)) return phoneNumber;
    
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`;
  }
}
